import Vue from 'vue'

export default {
  // state: JSON.parse(sessionStorage.getItem('user')) || {},
  state: {
    isLogin: false,
    user: {},
    isRefresh: false,
  },
  mutations: {
    /**
     * 登录成功
     *
     * @param {Object} state
     * @param {Object} user
     */
    SIGNIN(state, user) {
      state.user = user.user;
      state.isLogin = user.isLogin;
      state.isRefresh = user.isRefresh;
      // sessionStorage.setItem('user', JSON.stringify(user))
      // Object.assign(state, user)
    },
    /**
     * 退出登录
     *
     * @param {Object} state
     */
    SIGNOUT(state) {
      state.user = {};
      state.isLogin = false;
      state.isRefresh = false;
      console.log(state.isRefresh);
      // sessionStorage.removeItem('user')
      // Object.keys(state).forEach(k => Vue.delete(state, k))
    },

    /**
     * 更换头像
     *
     * @param {Object} state
     */
    replaceAvatar(state, value) {
      state.user.avatar = value;
      // sessionStorage.removeItem('user')
      // Object.keys(state).forEach(k => Vue.delete(state, k))
    }
  },
  actions: {
    SIGNIN({commit}, user) {
      commit('SIGNIN', user)
    },
    SIGNOUT({commit}) {
      commit('SIGNOUT')
    },
    replaceAvatar({commit}, value) {
      commit('replaceAvatar', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js